import products from "../data/products";
import Icon from "./Icon";
import SectionHeading from "./SectionHeading";

function Products() {
  return (
    <section className="section section--alt" id="products">
      <div className="container">
        <SectionHeading
          eyebrow="What We Build"
          title="Platforms That Scale With You"
          subtitle="Tailored platforms that streamline operations, boost collaboration, and scale with your business."
        />
        <div className="card-grid card-grid--3 reveal">
          {products.map((product) => (
            <article className="card-grid__item" key={product.id}>
              <div className="product-card">
                <div className="product-card__icon">
                  <Icon name={product.icon} size={44} />
                </div>
                <h3 className="product-card__title">{product.title}</h3>
                <p className="product-card__desc">{product.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Products;
